import { render } from "./PaginationTop.vue?vue&type=template&id=d8ad7fe0"
import script from "./PaginationTop.vue?vue&type=script&lang=js"
export * from "./PaginationTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__